export default (options) => {
    return () => {
        return {
            warning: options.translations.warnings.pwned,
            suggestions: [options.translations.suggestions.pwned],
        };
    };
};
//# sourceMappingURL=feedback.js.map